<template>
  <div v-if="isIndexShow" class="trade-in">
	<div v-if="followHid && isWeixin && isLogin" class="follow acea-row row-between-wrapper">
		<div>点击“立即关注”即可关注公众号</div>
		<div class="acea-row row-middle">
			<div class="bnt" @click="followTap">立即关注</div>
			<span class="iconfont icon-guanbi" @click="closeFollow"></span>
		</div>
	</div>
	<div class="followCode" v-if="followCode">
		<div class="pictrue"><img :src="followUrl" /></div>
		<div class="mask" @click="closeFollowCode"></div>
	</div>
    <ul class="trade-tabs">
		<li :class="isBoxShow ? '' : 'trade-tabs-show'" @click="videoTap()">视频产品验证</li>
		<li :class="isBoxShow ? 'trade-tabs-show' : ''" @click="bookTap()">图书产品验证</li>
	</ul>
	<div class="trade-box">
		<!-- 视频产品验证 -->
		<div v-if="!isBoxShow">
			<div class="trade-check-li">
				<p class="form-icon">视频产品合同编号</p>
				<input class="trade-input" type="text" v-model="contract_no">
			</div>
			<div class="trade-check-li">
				<p class="form-icon">签约时的手机号码</p>
				<input class="trade-input" type="number" pattern="[0-9]*" v-model="phone">
			</div>
			<div v-if="isCheckFail" class="check-fail-info trade-check-li">
				<p>验证未通过可能因为以下情况，请确认无误后重新验证：</p>
				<p>1.	您输入的合同编号有误</p>
				<p>2.	您输入的手机号码不是签合同时的手机号码</p>
				<p>如以上均无问题但仍无法通过验证，请联系工作人员人工验证。</p>
			</div>
			<div style="padding: 0 0.5rem 0.5rem 0.5rem;">
				<div v-if="!isCheckFail" @click="checkVideo()" class="trade-check-button">验证</div>
				<div v-if="isCheckFail" @click="checkVideo()" class="trade-check-button">重新验证</div>
			</div>
			<div class="h"></div>
			<ul v-if="tradeData.video_data.length > 0"  class="purchased-list">
				<li v-for="(item,key) in tradeData.video_data" :key="key">
					<p>视频合同编号{{ item.contract_no }}</p>
					<p style="margin-top: 0.2rem;">
						<span v-if="item.status == 1" class="purchased-left-weimai">未购买</span>
						<span v-if="item.status == 2" class="purchased-left-yimai">已购买</span>
						<span v-if="item.status == 3" class="purchased-left-weimai">已退货</span>
						<!-- <span v-if="item.status == 2 || item.status == 3" class="iconfont icon-fenxiang purchased-right"></span> -->
						<span v-if="item.status == 1" @click="setShareInfoStatus(item.id)" class="iconfont icon-fenxiang purchased-right font-color-red"></span>
					</p>
				</li>
			</ul>
		</div>
		<!-- 图书产品验证 -->
		<div v-if="isBoxShow">
			<div class="trade-check-li">
				<p class="form-icon">所购图书名称</p>
				<select name="purchasedName" class="trade-select" v-model="purchasedName">
					<option value="请选择">请选择</option>
					<option v-for="(item,key) in tradeData.image_name_config" :key="key" :value="item.id">{{item.name}}</option>
				</select>
			</div>
			<div class="trade-check-li">
				<p class="form-icon">所购图书数量</p>
				<select name="purchasedNum" class="trade-select" v-model="purchasedNum">
					<option value="请选择">请选择</option>
					<option v-for="(item,key) in tradeData.image_config" :key="key" :value="item.id">{{item.name}}</option>
				</select>
			</div>
			<div class="trade-check-li">
				<p class="form-icon">所购图书图片</p>
				<div
				  class="pictrue"
				  v-for="(img, index) in refund_reason_wap_img"
				  :key="img"
				>
				  <img :src="img" />
				  <div
				    class="iconfont icon-guanbi1 close-img"
				    @click="delImg(index)"
				  ></div>
				</div>
				<VueCoreImageUpload
				  class="btn btn-primary"
				  :crop="false"
				  compress="80"
				  @imageuploaded="imageuploaded"
				  :headers="headers"
				  :max-file-size="5242880"
				  :credentials="false"
				  inputAccept="image/*"
				  inputOfFile="file"
				  :url="url"
				  v-if="refund_reason_wap_img.length < 5"
				>
				  <div class="pictrue acea-row row-center-wrapper row-column">
				    <span class="iconfont icon-icon25201"></span>
				    <div>{{imgNum}}/5</div>
				  </div>
				</VueCoreImageUpload>
			</div>
			<div style="padding: 0 0.5rem 0.5rem 0.5rem;">
				<div @click="checkImage()" class="trade-check-button">验证</div>
			</div>
			<div class="h"></div>
			<ul v-if="tradeData.image_data.length > 0" class="purchased-list">
				<li v-for="(item,key) in tradeData.image_data" :key="key" v-if="tradeData.image_name_config[item.books_id]">
					<p>所购图书《{{tradeData.image_name_config[item.books_id].name}}》<span class="purchased-right">数量：{{tradeData.image_config[item.books_number].name}}</span></p>
					<p style="margin-top: 0.2rem;">
						<span v-if="item.status == 1" class="purchased-left-weimai">未购买</span>
						<span v-if="item.status == 2" class="purchased-left-yimai">已购买</span>
						<!-- <span v-if="item.status == 2" class="iconfont icon-fenxiang purchased-right"></span> -->
						<span v-if="item.status == 1" @click="setShareInfoStatus(item.id)" class="iconfont icon-fenxiang purchased-right font-color-red"></span>
					</p>
				</li>
			</ul>
		</div>
		<!-- 图书产品验证end -->
	</div>
	<ShareInfo
	  v-on:setShareInfoStatus="setShareInfoStatus"
	  :shareInfoStatus="shareInfoStatus"
	  :shareId="shareId"
	></ShareInfo>
  </div>
</template>

<script>
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import ShareInfo from "@components/ShareInfo";
import { oldnewIndex, oldnewVideo, oldnewImage } from "@api/activity";
 
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { mapGetters } from "vuex";
export default {
  name: "TradeIn",
  components: {
    VueCoreImageUpload,
	ShareInfo
  },
  computed: mapGetters(["isLogin"]),
  data() {
    return {
	  isWeixin: this.$wechat.isWeixin(),
	  shareInfoStatus: false,
	  shareId:1,
	  followUrl: "",
	  subscribe: false,
	  followHid: false,
	  followCode: false,
	  isIndexShow:false,
      isBoxShow:false,
	  contract_no:"",
	  phone:"",
	  isCheckFail:false,
	  purchasedName:"",
	  purchasedNum:"",
	  url: `${VUE_APP_API_URL}/upload/image`,
	  headers: {
	    "Authori-zation": "Bearer " + this.$store.state.app.token
	  },
	  refund_reason_wap_img: [],
	  imgNum:0,
	  tradeData:{
		image_config: {
			name:''
		},
		image_data: [
			{
				books_id:'',
				books_number:''
			}
		],
		image_name_config: {
			name:''
		},
		video_data: [],  
	  }
    };
  },
  created() {
    if (this.isLogin === false) {
      this.followHid = false;
    }
  },
  mounted() {
	// var useragent = navigator.userAgent;
	// if (useragent.match(/MicroMessenger/i) != 'MicroMessenger') {
	//     // 这里警告框会阻塞当前页面继续加载
	//     alert('请在微信客户端打开链接');
	//     // 以下代码是用javascript强行关闭当前页面
	//     var opened = window.open('about:blank', '_self');
	//     opened.opener = null;
	//     opened.close();
	// }
	this.getOldnewIndex();
	this.getFollow();
	let that = this;
	getHomeData(0).then(res => {
	  if (that.isLogin) {
	    that.subscribe = res.data.subscribe;
	    if (!that.subscribe && that.followUrl) {
	      setTimeout(function() {
	        that.followHid = true;
	      }, 200);
	    } else {
	      that.followHid = false;
	    }
	  } else {
	    that.followHid = false;
	  }
	  // that.setShareInfoStatus();
	});
	
  },
  methods: {
	// 关注公众号
	getFollow() {
	  follow()
	    .then(res => {
	      this.followUrl = res.data.path;
	    })
	    .catch(() => {});
	},
	closeFollow() {
	  this.followHid = false;
	},
	followTap() {
	  this.followCode = true;
	  this.followHid = false;
	},
	closeFollowCode() {
	  this.followCode = false;
	  this.followHid = true;
	},
	// 一进页面执行
	getOldnewIndex(){
		let that = this;
		oldnewIndex().then(res => {
			that.tradeData = res.data;
			that.isIndexShow = true;
			if(res.data.oldnew_display == 1){
				that.$router.push('/');
			}
			this.countTime();
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	countTime() {
		var that = this;
		var getTime = function(time){
			var myDate = new Date(time);
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //android终端
			var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
			if(isiOS){
				var t = new Date(time.replace(/-/g,'/')).getTime();
			}else{
				var t = myDate.getTime();
			}
			return t;    
		}      
		// 对结束时间进行处理渲染到页面
		let endTime = getTime(that.tradeData.oldnew_time);
		let newTime = new Date().getTime();
	　　 if (endTime - newTime <= 0){
			that.$dialog.error('活动已结束');
			setTimeout(function(){
				that.$router.push('/');
			},1500);
		}　　　
	},
	// 验证视频产品
	checkVideo(){
		this.countTime();
		let that = this;
		let data = {
			contract_no: that.contract_no,
			phone:that.phone
		}
		oldnewVideo(data).then(res => {
			// if(res.data.status == 200){
				that.isCheckFail = false;
				that.$router.push('/activity/trade_success');
			// }
		}).catch(err => {
			// if(err.data.status == 400){
				that.isCheckFail = true;
			// }
		});
	},
	// 验证图书产品
	checkImage(){
		this.countTime();
		let that = this;
		let data = {
			books_id: that.purchasedName,
			books_number:that.purchasedNum,
			books_images:that.refund_reason_wap_img.join(',')
		}
		oldnewImage(data).then(res => {
			that.$router.push('/activity/trade_success');
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	},
	// 顶部tab切换
    videoTap(){
		this.isBoxShow = false;
	},
	bookTap(){
		this.isBoxShow = true;
	},
	// 上传图片
	imageuploaded(res) {
	  if (res.status !== 200)
	    return this.$dialog.error(res.msg || "上传图片失败");
	  this.refund_reason_wap_img.push(res.data.url);
	  if(this.imgNum < 5) this.imgNum++;
	  
	},
	// 删除图片
	delImg(index){
		this.refund_reason_wap_img.splice(index, 1);
		if(this.imgNum >= 0) this.imgNum--;
	},
	// 分享
	setShareInfoStatus(id) {
	  this.countTime();
	  this.shareId = id;
	  if (this.$wechat.isWeixin()) {
		this.shareInfoStatus = !this.shareInfoStatus;
		oldnewIndex().then(res => {
			var data = res.data.share;
			var link = data.url + id;
			var configAppMessage = {
			  desc: data.desc,
			  title: data.title,
			  link: link,
			  imgUrl: data.image,
			  success: function(res){
				  console.log('成功')
			  },
			  fail: function(res){
				  console.log('失败')
				  console.log(res)
			  }
			};
			openShareAll(configAppMessage);
		}).catch(err => {
			that.$dialog.error(err.msg);
		});
	  }
	},
	
  },
  
};
</script>
<style scoped>
.trade-tabs{padding: 0.2rem 0;display: flex;justify-content: center;background-color: #fff;}
.trade-tabs li{text-align: center;width: 50%;color: #666;height: 0.48rem;line-height: 0.48rem;}
.trade-tabs li:first-child{border-right: 1px solid #d9d9d9;}
.trade-tabs .trade-tabs-show{color: #333;font-weight: bold;}
.trade-box{margin-top: 0.16rem;background-color: #fff;overflow: hidden;}
.trade-box .trade-check-li{margin-top: 0.5rem;overflow: hidden;padding: 0 0.5rem;}
.form-icon{margin-bottom: 0.2rem;font-size: 0.28rem;color: #333;}
.trade-input{border: 1px solid #cccccc;width: 100%;border-radius: 5px;text-indent: 0.27rem;padding: 0.17rem 0;}
.trade-box>div .trade-check-button{text-align: center;width: 100%;height: 0.8rem;line-height: 0.8rem;background-color: #ef3841;color: #fff;border-radius: 5px;margin-top: 0.7rem;}
.trade-select{border: 1px solid #cccccc;border-radius: 5px;height: 0.78rem;width: 100%;text-indent: 0.27rem;background: url(../../assets/images/select_bg.png) no-repeat center right;background-size: 0.44rem 0.1rem;}
.trade-box .check-fail-info p{color: #ef3841;font-size: 0.26rem;}
.pictrue{border: 1px dashed #999;width: 1.1rem;height: 1.1rem;border-radius: 5px;float: left;margin-right: 0.2rem;position: relative;}
.pictrue img{width: 100%;height: 100%;}
.close-img{position: absolute;top: -0.18rem;right: -0.18rem;}
.h{width: 100%;height: 0.16rem;background-color: #f5f5f5;}
.purchased-list{background-color: #fff;padding: 0 0.5rem;}
.purchased-list li{border-bottom: 1px solid #f0f0f0;padding: 0.3rem 0;}
.purchased-list li:last-child{border-bottom: none;}
.purchased-right{float: right;}
.purchased-left-yimai{background-color: #f3981c;color: #fff;display: inline-block;padding: 0.05rem 0.2rem;border-radius: 3px;}
.purchased-left-weimai{background-color: #a0a0a0;color: #fff;display: inline-block;padding: 0.05rem 0.2rem;border-radius: 3px;}
.trade-in .follow{width:100%;background-color:rgba(0,0,0,0.36);height:0.8rem;font-size:0.28rem;color:#fff;padding: 0 0.3rem;}
.trade-in .follow .bnt{width:1.6rem;height:0.5rem;background-color:#E93323;border-radius:0.25rem;font-size:0.24rem;text-align:center;line-height:0.5rem;}
.trade-in .follow .iconfont{font-size:0.3rem;margin-left:0.29rem;}
.trade-in .followCode .pictrue{width:5rem;height:7.2rem;border-radius:12px;left:50%;top:50%;margin-left:-2.5rem;margin-top:-3.6rem;position:fixed;z-index:666;}
.trade-in .followCode .pictrue img{width:100%;height:100%;}
</style>
